<!-- 汇率字典 -->
 <template>
    <div>
        <el-form  size="mini" :inline="true" :model="searchForm" class="demo-form-inline margin" label-width="100px">
            <el-form-item label="开始日期">
                <el-date-picker v-model="searchForm.startDate" type="date" placeholder="选择开始日期"
                value-format="yyyy-MM-dd" :picker-options="pickerStart"> </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
                <el-date-picker v-model="searchForm.endDate" type="date" placeholder="选择结束日期"
                value-format="yyyy-MM-dd" :picker-options="pickerEnd"> </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getData" size="small">查询</el-button>
                <el-button v-if="rolePermission === '领导'" type="primary" @click="addexchange" size="small">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="exchangeList"  style="width: 100%" :header-cell-style="{'text-align':'center'}" size="mini">
            <el-table-column type="index"  width="100" label="序号" align="center"></el-table-column>
            <el-table-column prop="exchangeRate" label="汇率" align="center"> 
                <template slot-scope="scope">
                    <span  v-format="'#,##0'">{{ scope.row.exchangeRate }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center">  </el-table-column>
            <el-table-column prop="startDate" label="开始日期" align="center">   </el-table-column>
            <el-table-column prop="endDate" label="结束日期" align="center">  </el-table-column>
            <el-table-column label="操作" width="200" align="center">  
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 新增编辑弹窗 -->
        <el-dialog :title="codeDialog === 0 ? '新增汇率':'编辑汇率'" :visible.sync="exitDialog"  width="40%" :before-close="handleClose">
            <el-form :rules="exitrules" ref="exitForm"  size="mini" :model="exitForm" label-width="100px" >
                <el-form-item prop="exchangeRate"  label="汇率">
                    <el-input v-model="exitForm.exchangeRate" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" placeholder="请输入汇率"></el-input>
                </el-form-item>
                <el-form-item prop="startDate"  label="开始日期">
                    <el-date-picker class="width_100" v-model="exitForm.startDate" type="date" placeholder="选择开始日期"
                    value-format="yyyy-MM-dd" :picker-options="pickerStartExit"> </el-date-picker>
                </el-form-item>
                <el-form-item  prop="endDate"  label="结束日期">
                    <el-date-picker class="width_100" v-model="exitForm.endDate" type="date" placeholder="选择结束日期"
                    value-format="yyyy-MM-dd" :picker-options="pickerEndExit"> </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="saveExchangeRate('exitForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import req from '@/utils/index.js'
import url from '@/config/url2.js'
export default {
    data() {
        return {
            rolePermission:localStorage.getItem('role'),
            searchForm:{ // 查询
                startDate:'',
                endDate:''
            },
            // 汇率表格
            exchangeList:[],
            exitDialog:false, // 弹窗显示
            exitForm:{ // 新增编辑表单
                exchangeRate:'',
                startDate:'',
                endDate:'',
                id:'',
            },
            codeDialog:0, // 新增:0  编辑:1 
            pickerStart:{
                disabledDate: time => {
                // 如果有 结束 日期 要选择结束之前的日期
                    if(this.searchForm.endDate){
                        return (
                        // 结束日期 小于 开始日期（开始日期不能选择 结束日期之后的日期）
                        new Date(this.searchForm.endDate).getTime() < time.getTime() 
                        );
                    }else{
                        // 如果没有结束日期 那么都可以选
                        return false
                    }
                }
            },
            pickerEnd:{
                disabledDate: time => {
                    // 如果有开始日期 
                    if(this.searchForm.startDate){
                        return (
                        // 开始日期 必须大于 结束日期（结束日期不能选择开始之前的日期） 
                        // 而 -3600*24*1000 减去 一天的时间可以选择当天日期
                        (
                            (
                            new Date(this.searchForm.startDate).getTime()
                            )-3600*24*1000
                        )
                        >
                        (time.getTime())
                        );
                    }else{
                        // 如果没有开始日期 都可以选择
                        return false
                    }
                }
            },
            pickerStartExit:{
                disabledDate: time => {
                // 如果有 结束 日期 要选择结束之前的日期
                    if(this.exitForm.endDate){
                        return (
                        // 结束日期 小于 开始日期（开始日期不能选择 结束日期之后的日期）
                        new Date(this.exitForm.endDate).getTime() < time.getTime() 
                        );
                    }else{
                        // 如果没有结束日期 那么都可以选
                        return false
                    }
                }
            },
            pickerEndExit:{
                disabledDate: time => {
                    // 如果有开始日期 
                    if(this.exitForm.startDate){
                        return (
                        // 开始日期 必须大于 结束日期（结束日期不能选择开始之前的日期） 
                        // 而 -3600*24*1000 减去 一天的时间可以选择当天日期
                        (
                            (
                            new Date(this.exitForm.startDate).getTime()
                            )-3600*24*1000
                        )
                        >
                        (time.getTime())
                        );
                    }else{
                        // 如果没有开始日期 都可以选择
                        return false
                    }
                }
            },
            // 编辑汇率规则
            exitrules: {
                exchangeRate: [
                    { required: true, message: '请输入汇率', trigger: 'blur' },
                ],
                startDate: [
                    { required: true, message: '请选择开始日期', trigger: 'change' }
                ],
                endDate: [
                    { required: true, message: '请选择结束日期', trigger: 'change' }
                ],
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        // 查询
        getData(){
            let URL = `${url.getListBy}`;
            req.get(URL,{
                params:{
                    startDate:this.searchForm.startDate,
                    endDate:this.searchForm.endDate
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.exchangeList = res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        // 新增
        addexchange(){
            this.codeDialog = 0
            this.exitDialog = true
        },
        // 编辑
        handleEdit(data){
            this.exitForm.id = data.id
            this.exitForm.startDate = data.startDate
            this.exitForm.endDate = data.endDate
            this.exitForm.exchangeRate = data.exchangeRate
            this.codeDialog = 1
            this.exitDialog = true  
        },
        // 关闭弹窗
        handleClose(){
            this.exitDialog = false
            this.exitForm = { }
            this.$refs.exitForm.resetFields()

        },
        // 保存汇率
        saveExchangeRate(form){
            this.$refs[form].validate((valid) => {
                if(valid){
                    let URL = `${url.saveOrUpdateExchangeRate}`;
                    req.post(URL,this.exitForm).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.exitForm = { }
                            this.$refs.exitForm.resetFields()
                            this.exitDialog = false
                            this.getData()
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }else{
                    return false
                }
            })
        }
    }
}
</script>
<style lang="css" scoped>
.margin{
    margin-top: 10px;
}
.width_100{
    width: 100%;
}
::v-deep .el-table {
    margin-top: 0px;
}
</style>